import React,{useState} from 'react';
import useForm from 'react-hook-form';
import Alert from '../alert/alert';
import Navbar from '../layout/Navbar';
import Footer from '../footer/Footer';
import SideDrawer from '../SideDrawer/SideDrawer';
import ApiContext from '../Context/ApiContext';

const ContactUs = (props) => {
  const { showSuccess, showFailed } = new Alert();
  const { register, handleSubmit, errors } = useForm();
  const [sideDrawerStatus , setSideDrawer] = useState(false);

  const onSubmit = (data) => {
    showSuccess('Yippy! Thanks for contacting Us');
    props.history.push('/');
  };
  return (

    <ApiContext.Provider value={{
      sideDrawerStatus : sideDrawerStatus,
      setSideDrawer : (()=> setSideDrawer(!sideDrawerStatus))
    }}>
    <div className="main contact">
      <SideDrawer />
      <Navbar />
      <div className="ui white text container" style={{ padding: '2rem' }}>
        <h1 className="text-center" style={{ paddingTop: '4rem' }}>
          Contact Us
        </h1>

          <form className="ui form" onSubmit={handleSubmit(onSubmit)}>
            <h3 style={{ paddingTop: '4rem' }}>Gat something to say? We'll be glad to hear from you</h3>
            <hr style={{ paddingBottom: '2rem' }} />
            <div className="field">
              <div className="two fields">
                <div className="field">
                  {errors.firstName && (
                    <p className="text-danger">This field is required and most be a minimun of 3 letters</p>
                  )}
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name"
                    ref={register({ required: true, minLength: 3 })}
                  />
                </div>
                <div className="field">
                  {errors.lastName && (
                    <p className="text-danger">This field is required and most be a minimun of 3 letters</p>
                  )}
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name"
                    ref={register({ required: true, minLength: 3 })}
                  />
                </div>

                  <div className="field">
                  {errors.lastName && (
                    <p className="text-danger">This field is required and most be a minimun of 3 letters</p>
                  )}
                  <input
                    type="email"
                    name="email"
                    placeholder="Your Email Address..."
                  />
                </div>
              </div>
            </div>

            <div className="field">
              <textarea
                placeholder="Enter your message here..."
                name="text"
              ></textarea>
            </div>
            <button className="btnSubmit" type="submit">
              Submit
            </button>
          </form>
        </div>
      <Footer />
    </div>
    </ApiContext.Provider>
  );
};

export default ContactUs;
